import Vue from "vue";
import VueRouter from "vue-router";
import home from "@/components/Home.vue"
import consulta from "@/components/Consulta.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: home,
  },
  {
    path: "/consulta",
    name: "Consulta",
    component: consulta,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
